import List from '../../services/List';

export default {
    namespaced: false,
    state: {
        list: [],
        wishlist: [],
        recommendations: [],
        viewed: []
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        },
        PUSH_LIST(state, data) {
            state.list.push(data);
        },
        REMOVE_LIST(state, id) {
            state.list.forEach((element, index) => {
                if (
                    element.product_id === id &&
                    element.status === 'favorites'
                ) {
                    state.list.splice(index, 1);
                }
            });
        },
        REMOVE_LIST_WISHLIST(state, data) {
            state.list.forEach((element, index) => {
                if (
                    element.product_id === data.id &&
                    element.status === data.wish_id
                ) {
                    state.list.splice(index, 1);
                }
            });
        },
        SET_WISHLIST_LIST(state, data) {
            state.wishlist = data;
        },
        PUSH_WISHLIST(state, data) {
            if (data !== null) {
                state.wishlist.push(data);
            }
        },
        SET_RECOMMENDATIONS(state, data) {
            state.recommendations = data;
        },
        SET_VIEWED(state, data) {
            state.viewed = data;
        }
    },
    actions: {
        addToFavorites({ commit }, id) {
            const response = List.addToFavorites(id);
            response.then(res => {
                commit('PUSH_LIST', res.data);
            });
        },
        removeFromFavorites({ commit }, id) {
            const response = List.removeFromFavorites(id);
            response.then(res => {
                commit('REMOVE_LIST', res.data.id);
            });
        },
        async getList({ commit }) {
            const res = await List.getList();
            commit('SET_LIST', res.data);
            this.dispatch('getWishlist');
        },
        async createWishlist({ commit }, data) {
            const res = await List.createWishlist(data);
            commit('PUSH_LIST', res.data.list);
            commit('PUSH_WISHLIST', res.data.wishlist);
        },
        createWishlistNoProduct({ commit }, title) {
            const response = List.createWishlistNoProduct(title);
            response.then(res => {
                if (res.data.error) {
                    alert(res.data.error);
                    commit('SET_WISHLIST_LIST', res.data.data);
                } else {
                    commit('PUSH_WISHLIST', res.data);
                }
            });
        },
        addToWishlist({ commit }, obj) {
            const response = List.addToWishlist(obj);
            response.then(res => {
                commit('PUSH_LIST', res.data);
            });
        },
        removeFromWishlist({ commit }, obj) {
            const response = List.removeFromWishlist(obj);
            response.then(res => {
                commit('REMOVE_LIST_WISHLIST', res.data);
            });
        },
        getWishlist({ commit }) {
            const response = List.getWishlist();
            response.then(res => {
                commit('SET_WISHLIST_LIST', res.data);
            });
        },
        getRecommendations({ commit }) {
            const response = List.getRecommendations();
            response.then(res => {
                commit('SET_RECOMMENDATIONS', res.data);
            });
        },
        getViewed({ commit }) {
            const response = List.getViewed();
            response.then(res => {
                commit('SET_VIEWED', res.data);
            });
        }
    }
};
